module.exports = "/ui/main/images/points_icon.png?df0876ae943e431cd3f58d8aecf06ff8";